// extracted by mini-css-extract-plugin
module.exports = {"students":"Students_students__1UI4w","filters":"Students_filters__1FU3B"};